import {ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, Renderer2, ViewChild} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ClientService} from '../../Services/client.service';
import {AuthService} from '../../auth/AuthService';
import {Router} from '@angular/router';
import {PatientService} from '../../Services/patient.service';
import {first} from 'rxjs/operators';
import swal from "sweetalert2";
import {Sort} from '@angular/material/sort';
import {RulesService} from '../../Services/rules.service';
import {Subject} from "rxjs";

@Component({
  selector: 'pm-rules-registration',
  templateUrl: './rules-registration.component.html',
  styleUrls: ['./rules-registration.component.css']
})
export class RulesRegistrationComponent implements OnInit {

  tableData: any = [];
  phoneType: any = [
    {value: 'Mobile', viewValue: 'Mobile'},
    {value: 'Work', viewValue: 'Work'},
    {value: 'Home', viewValue: 'Home'},
  ];
  fileImage: string | null = null; // Variable to hold the image URL
  files: File[] = [];
  isDragOver: boolean = false;
  errorMessages: any;
  errorMessagePart:any;
  searchText: any;
  private clientSub: any;
  private subject: Subject<string> = new Subject();

  constructor(private fb: FormBuilder,
              private clientServices: ClientService,
              public authService: AuthService,
              private router : Router,
              private renderer: Renderer2,
              private ruleServices: RulesService,
              private cdr: ChangeDetectorRef,
              private ngZone: NgZone) {
  }

  ngOnInit(): void {
    this._fetchData(1);
    this.clientSub = this.authService.clientIdSubject.subscribe((clientId: number | null) => {
      if (clientId) {
        this._fetchData(1);
      }
    });
  }
  ngOnDestroy(): void {
    this.clientSub?.unsubscribe();
  }

  // Get Rules data
  _fetchData(type: any) {
    const params: { [key: string]: any } = {
      clientId: this.authService.clientId
    };

    if (type === 2) {
      params.active = true;
    } else if (type === 3) {
      params.active = false;
    }

    this.ruleServices.getAllRules(params).pipe(first()).subscribe(
      (response: any) => {
        this.ngZone.run(() => {
          if (response && response.length > 0) {
            this.tableData = response;
          } else {
            this.tableData = [];
            this.cdr.detectChanges();

            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response?.message || 'No data found',
              showConfirmButton: false,
              timer: 5000
            });
          }

          setTimeout(() => {
            this.cdr.detectChanges();
          }, 0);
        });
      },
      (error) => {
        this.ngZone.run(() => {
          this.tableData = [];
          this.cdr.detectChanges();

          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error?.error?.message || '',
            showConfirmButton: false,
            timer: 5000
          });
        });
      }
    );
  }

  // Search
  onKeyUp(searchTextValue: any): void {
    this.subject.next(searchTextValue);
  }

  handleKeyUp(event: KeyboardEvent) {
    const value = (event.target as HTMLInputElement).value;

    // Trigger search on Enter
    if (event.key === 'Enter') {
      this.onKeyUp(this.searchText);
      return;
    }

    // Existing debounce logic
    this.subject.next(value);
  }
  clearSearch(input: HTMLInputElement) {
    input.value = '';
    /*this.searchString = '';*/
    /*this.pagination.currentPage = 0;
    this.pagination.page = 1;*/
    this._fetchData(1);
  }

  // Delete record
     deleteEntry(ruleId: any) {
          let reqData = {
              ruleId: ruleId,
              clientId: this.authService.clientId
          };
          swal.fire({
              title: 'Are you sure?',
              text: 'You want to delete this record ?',
              icon: 'warning',
              iconColor: 'red',
              showCancelButton: true,
              confirmButtonText: 'Yes !'
          }).then((result) => {
              if (result.isConfirmed) {
                  this.ruleServices.deleteRule(reqData).pipe(first()).subscribe(
                      (response: any) => {
                          if (response) {
                              this._fetchData(1);
                              swal.fire({
                                title: 'success!',
                                icon: 'success',
                                text: 'Rule Deleted Successfully!',
                                showConfirmButton: true,
                                timer: 2000
                              });
                          } else {
                              swal.fire({
                                  title: 'Error!',
                                  icon: 'error',
                                  text: 'Something went wrong!',
                                  showConfirmButton: false,
                                  timer: 2000
                              });
                          }
                      },
                      (error) => {
                          swal.fire({
                              title: 'Error!',
                              icon: 'error',
                              text: 'Failed to communicate with the server!',
                              showConfirmButton: false,
                              timer: 2000
                          });
                      });
              }
          });
      }

  // Update entry
  /*    updateEntry = (clientId: any) => {
          this.router.navigate(['client/details/' + clientId]).then();
      }*/

  // Sort form frontend logic
  sortData(sort: Sort) {
    const data = this.tableData.slice();
    if (!sort.active || sort.direction === '') {
      this.tableData = data;
      return;
    }

    this.tableData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name':
          return compare(a.name, b.name, isAsc);
        case 'email':
          return compare(a.email, b.email, isAsc);
        case 'number':
          return compare(a.number, b.number, isAsc);
        case 'active':
          return compare(a.active, b.active, isAsc);
        default:
          return 0;
      }
    });
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
